<template>
  <div class="col-sm-12 col-md-12">


    <div class="card">
      <div class="card-body">
        <div class="loading" v-if="processando">
          <div class="progress"> 
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
          </div> 
        </div>
        <div class="animated fadeIn">
           <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
            aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
            data-backdrop="static" v-if="showModalDadosVeiculo">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h4 class="modal-title">Dados do Veículo</h4>
                </div>  
                <div class="modal-body">                  
                    <div class="tabbable">
                      <!-- Only required for left/right tabs -->
                      <ul class="nav nav-tabs">
                        <li class="nav-item active"><a href="#tab1" data-toggle="tab" class="nav-link active">Veículo</a></li>
                        <li class="nav-item"><a href="#tab2" data-toggle="tab" class="nav-link" v-on:click="buscarGridDadosVeiculoContatoCliente(), buscarGridDadosVeiculoContatoClientePaga()" >Contatos</a></li>
                        <li class="nav-item"><a href="#tab2" data-toggle="tab" class="nav-link" v-on:click="buscarGridCliente()" >Ações</a></li>
                      </ul>

                      <div class="tab-content">
                        <div class="tab-pane active" id="tab1">
                          <div class="row">
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Data da Cadastro</strong></label><br>
                              {{dadosVeiculo.veiculoDataCadastro}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Marca</strong></label><br>
                              {{dadosVeiculo.veiculoMarca}}
                            </div>
                            <div class="form-group col-sm-4 col-md-4">
                              <label><strong>Modelo</strong></label><br>
                              {{dadosVeiculo.veiculoModelo}}
                            </div>
                          </div>                 
                          <div class="row">
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Data da instalação</strong></label><br>
                              {{dadosVeiculo.equipamentoDataInstalacao}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Serial</strong></label><br>
                              {{dadosVeiculo.equipamentoSerial}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Marca</strong></label><br>
                              {{dadosVeiculo.equipamentoMarca}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Modelo</strong></label><br>
                              {{dadosVeiculo.equipamentoModelo}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Operadora</strong></label><br>
                              {{dadosVeiculo.equipamentoOperadora}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Numero do Chip</strong></label><br>
                              {{dadosVeiculo.equipamentoNumero}}
                            </div>
                          </div>

                          
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12">
                              <label><strong>Observação</strong></label><br>
                              {{dadosVeiculo.veiculoObservação01}}
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12">
                              <label><strong>Observação</strong></label><br>
                              {{dadosVeiculo.veiculoObservação02}}
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-12 col-md-12">
                              <label><strong>Senha</strong></label><br>
                              {{dadosVeiculo.veiculoSenha}}
                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-sm-4 col-md-4">
                              <label><strong>Cliente</strong></label><br>
                              {{dadosVeiculo.clienteNome}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Telefone</strong></label><br>
                              {{dadosVeiculo.clienteTelefone}}
                            </div>
                            <div class="form-group col-sm-6 col-md-6">
                              <label><strong>Email</strong></label><br>
                              {{dadosVeiculo.clienteEmail}}
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-sm-4 col-md-4">
                              <label><strong>Cliente Paga</strong></label><br>
                              {{dadosVeiculo.clientePagaNome}}
                            </div>
                            <div class="form-group col-sm-2 col-md-2">
                              <label><strong>Telefone</strong></label><br>
                              {{dadosVeiculo.clientePagaTelefone}}
                            </div>
                            <div class="form-group col-sm-6 col-md-6">
                              <label><strong>Email</strong></label><br>
                              {{dadosVeiculo.clientePagaEmail}}
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="tab2">

                           <table id="contatosAdicionais"
                              class="responsive datatable_ajax display table table-striped table-hover"
                              width="100%">
                              <thead class="thead-light">
                                <th>Nome</th>
                                <th>Telefone</th>
                                <th>Email</th>
                              </thead>
                              <tbody>
                                <tr v-for="(contato, i) in dadosVeiculoContatoCliente">
                                    <td>{{contato.nome}}</td>
                                    <td>{{contato.telefone}}</td>
                                    <td>{{contato.email}}</td>
                                </tr>
                              </tbody>
                            </table>

                            <table id="contatosAdicionais"
                              class="responsive datatable_ajax display table table-striped table-hover"
                              width="100%">
                              <thead class="thead-light">
                                <th>Nome</th>
                                <th>Telefone</th>
                                <th>Email</th>
                              </thead>
                              <tbody>
                                <tr v-for="(contato, i) in dadosVeiculoContatoClientePaga">
                                    <td>{{contato.nome}}</td>
                                    <td>{{contato.telefone}}</td>
                                    <td>{{contato.email}}</td>
                                </tr>
                              </tbody>
                            </table>
                              
                        </div>
                        <div class="tab-pane" id="tab3">
                        </div>
                      </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalDadosVeiculo = false">Fechar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            
            <div class="">
              <div class="">
                <div class="row">
                  <div class="col-sm-3 col-md-8 col-lg-8 form-group">
                    <label>Busca</label>
                    <input id="busca" name="busca" class="form-control" type="text" v-model="busca" v-on:keyup.enter="buscarGrid(), buscarGridAlertaRoubo()"> 
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 velocidade no-gutter">
                    <label>Velocidade</label>
                    <input id="velocidade" name="velocidade" class="form-control" type="text" v-model="velocidade" v-on:keyup.enter="buscarGrid(), buscarGridAlertaRoubo()">
                  </div>
                  <div class="col-sm-2 col-md-2 col-lg-2 atualizacao no-gutter">
                    <label>&nbsp;</label>
                    <select v-model="atualizarGrid" class="form-control" v-on:change="startInterval">
                      <option value="0">Não Atualiza</option>
                      <option value="300000">5 Minutos</option>
                      <option value="180000">3 Minutos</option>
                      <option value="60000">1 Minuto</option>
                    </select>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 atualizacao no-gutter">
                    <label>&nbsp;</label><br>
                    <button class="btn btn-success btn-block" v-on:click="buscarGrid(), buscarGridAlertaRoubo()">Buscar</button>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="dadosTabelaAlertaRoubo.length > 0">
              <div class="row" >
                <div class="col-sm-12 col-md-12">
                  <div>
                    <h4 class="text-danger">VEÍCULOS EM ALERTA DE ROUBO</h4>
                    
                    <table  class="table table-responsive-sm table-hover table-outline mb-0">
                      <thead class="thead-light">
                        <tr>
                          <th style="width: 120px">Data e Hora</th>
                          <th style="width: 250px">Descrição do Veículo</th>
                          <th>Ponto mais próximo</th>
                          <th style="width: 60px">Km/h</th>
                          <th style="width: 20px">IGN</th>
                          <th style="width: 21px">GPS</th>
                          <th style="width: 24px">GSM</th>
                          <th style="width: 26px">MOV</th>
                          <th style="width: 31px">Tensão</th>
                        </tr>
                      </thead>

                      <tbody v-for="(grid, i) in dadosTabelaAlertaRoubo">
                        <tr :class="{ 'selecionado': selecionado(grid) }" @click="selecionarItem(grid)" v-on:dblclick="editar(grid.idVeiculo)">
                          <td><small class="text-danger"><strong>{{grid.dataHora}}</strong></small></td>
                          <td><small class="text-danger"><strong>{{grid.descricaoVeiculo}}</strong></small></td>
                          <td><small class="text-danger"><strong>{{grid.pontoMaisProximo}}</strong></small></td>
                          <td><small class="text-danger"><strong>{{formatarVelocidade(grid.velocidade)}}</strong></small></td>
                          <td>
                            <template v-if="grid.ignicaoDesativada">
                              <img src="/static/images/disable.png" />
                            </template>
                            <template v-else>
                              <template v-if="grid.ignicao">
                                <img src="/static/images/true.png" />
                              </template>
                              <template v-else>
                                <img src="/static/images/false.png" />
                              </template>
                            </template>
                          </td>
                          <td>
                            <template v-if="grid.gps">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </td>
                          <td>
                            <template v-if="grid.gprs">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </td>
                          <td>
                            <template v-if="grid.movimentoDesativada">
                              <img src="/static/images/disable.png" />
                            </template>
                            <template v-else>
                              <template v-if="grid.movimento">
                                <img src="/static/images/true.png" />
                              </template>
                              <template v-else>
                                <img src="/static/images/false.png" />
                              </template>
                            </template>
                          </td>
                          <td>
                            <template v-if="grid.alertaTensao === 'true'">
                              <small class="text-warning"><strong>{{formatarVelocidade(grid.tensao)}}</strong></small>
                            </template>
                            <template v-else>
                              <small class="text-muted">{{formatarVelocidade(grid.tensao)}}</small>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <br>
                    </div>
                  </div>
                </div>
            </template>
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <div id="dados-grid">
                  <table  class="table table-responsive-sm table-hover table-outline mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 120px">Data e Hora</th>
                        <th style="width: 250px">Descrição do Veículo</th>
                        <th>Ponto mais próximo</th>
                        <th style="width: 60px">Km/h</th>
                        <th style="width: 20px">IGN</th>
                        <th style="width: 21px">GPS</th>
                        <th style="width: 24px">GSM</th>
                        <th style="width: 26px">MOV</th>
                        <th style="width: 31px">Tensão</th>
                      </tr>
                    </thead>
                    <tbody v-for="(grid, i) in dadosTabela">
                      <template v-if="i === 0">
                        <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                          <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                        </tr>
                      </template>
                      <template v-if="i > 0">
                        <template v-if="dadosTabela[i].clienteIdVeiculo != dadosTabela[i-1].clienteIdVeiculo">
                        <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                          <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                        </tr>
                        </template>
                      </template>
                      <tr :class="{ 'selecionado': selecionado(grid) }" @click="selecionarItem(grid)" v-on:dblclick="editar(grid.idVeiculo)">
                        <td><small class="text-muted">{{grid.dataHora}}</small></td>
                        <td>
                          <template v-if="grid.vencidos > 0">
                            <img src="/static/images/dinheiro.png" v-tooltip="'Possui débitos vencidos'"/> 
                          </template>
                          <template v-if="$auth.check('P110')">
                            <small class="text-muted"><a href="#" v-on:click="mostrarDadosVeiculo(grid.idVeiculo)" > {{grid.descricaoVeiculo}}</a></small>
                          </template>
                          <template v-else> 
                            <small class="text-muted">{{grid.descricaoVeiculo}}</small>
                          </template>
                        </td>
                        <td><small class="text-muted">{{grid.pontoMaisProximo}}</small></td>
                        <td>
                          <template v-if="grid.alertaVelocidade === 'true'"> 
                            <small class="text-danger"><strong>{{formatarVelocidade(grid.velocidade)}}</strong></small>
                          </template>
                          <template v-else>
                            <small class="text-muted">{{formatarVelocidade(grid.velocidade)}}</small>
                          </template>
                        </td>
                        <td>
                          <template v-if="grid.possuiIgnicao">
                            <template v-if="grid.ignicao">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </template>
                          <template v-else>
                            <img src="/static/images/disable.png" />
                          </template>
                        </td>
                        <td>
                          <template v-if="grid.possuiGps">
                            <template v-if="grid.gps">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </template>
                          <template v-else>
                            <img src="/static/images/disable.png" />
                          </template>
                        </td>
                        <td>
                          <template v-if="grid.possuiGprs">
                            <template v-if="grid.gprs">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </template>
                          <template v-else>
                            <img src="/static/images/disable.png" />                            
                          </template>
                        </td>
                        <td>
                          <template v-if="grid.possuiMovimento">
                            <template v-if="grid.movimento">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </template>
                          <template v-else>
                            <img src="/static/images/disable.png" />
                          </template>
                        </td>
                        <td>
                          <template v-if="grid.alertaTensao === 'true'">
                            <small class="text-warning"><strong>{{formatarVelocidade(grid.tensao)}}</strong></small>
                          </template>
                          <template v-else>
                            <small class="text-muted">{{formatarVelocidade(grid.tensao)}}</small>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      atualizarGrid: 0,
      atualizarGridInterval: '',
      selecionada: '0',
      dadosTabela: [],
      dadosTabelaAlertaRoubo: [],
      processando: true,
      showModalDadosVeiculo: false,
      dadosVeiculo: [],
      dadosVeiculoContatoCliente: [],
      dadosVeiculoContatoClientePaga: []
    }
  },
  created: function () {
    this.buscarGrid()
    this.buscarGridAlertaRoubo()
  },
  methods: {
    startInterval: function () {
      let self = this
      console.log('set interval')
      if (self.atualizarGrid === 0 || self.atualizarGrid === '0') {
        clearInterval(self.atualizarGridInterval)
      } else {
        self.atualizarGridInterval = setInterval(() => {
          self.buscarGrid()
        }, self.atualizarGrid)
      }
    },
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    setMixPanel: function () {
      var data = this.$auth.user()
      this.$ma.setUserProperties({userId: data.uid, UserId: data.uid, name: data.name, Name: data.name, Email: '', Company: 'Spark'})
      this.$ma.setAlias(data.name)
      this.$ma.setUsername(data.name)
    },
    buscarDadosEmpresa: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/verificarCadastroEmpresa'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        if (response.data === false) {
          self.$router.replace('/empresa')
        }
      })
    },
    buscarGridAlertaRoubo: function () {
      var self = this
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=true'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosTabelaAlertaRoubo = dadosCadastro.dados
      })
    },
    buscarGrid: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=false'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosTabela = dadosCadastro.dados
        self.processando = false
      })
    },
    mostrarDadosVeiculo: function (veiculo) {
      let self = this
      self.dadosVeiculo = []
      self.processando = true
      self.showModalDadosVeiculo = true
      self.buscarGridDadosVeiculo(veiculo)
    },
    buscarGridDadosVeiculo: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gridDadosVeiculo?veiculo=' + veiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculo = dadosCadastro
        self.processando = false
      })
    },
    buscarGridDadosVeiculoContatoCliente: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clienteId
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculoContatoCliente = dadosCadastro
        self.processando = false
      })
    },
    buscarGridDadosVeiculoContatoClientePaga: function (veiculo) {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clientePagaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculoContatoClientePaga = dadosCadastro
        self.processando = false
      })
    },
    buscarVendasProdutosMaisVendidosPeriodo: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.vendasProdutosMaisVendidosPeriodoDados = response.data
      })
    },
    buscarRealizadoReceberPeriodo: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/financeiroReceberPeriodo?periodo=' + this.financeiroPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento
      axios.get(url, config)
      .then(function (response) {
        let receber = []
        let recebido = []
        for (let i = 0; i < response.data.length; i++) {
          receber = response.data[i].valorTotal
          recebido = response.data[i].valorTotalPago
        }
        self.realizadoReceber = {
          labels: ['Receber', 'Recebido'],
          datasets: [
            {
              label: 'Receber',
              backgroundColor: ['#FF9800', '#42A5F5'],
              data: [receber, recebido]
            }
          ]
        }
      })
    },
    buscarRealizadoPagarPeriodo: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/financeiroPagarPeriodo?periodo=' + this.financeiroPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento
      axios.get(url, config)
      .then(function (response) {
        let pagar = []
        let pago = []
        for (let i = 0; i < response.data.length; i++) {
          pagar = response.data[i].valorTotal
          pago = response.data[i].valorTotalPago
        }
        self.realizadoPagar = {
          labels: ['Pagar', 'Pago'],
          datasets: [
            {
              label: 'pagar',
              backgroundColor: ['#F4511E', '#42A5F5'],
              data: [pagar, pago]
            }
          ]
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/Grid.vue